import {Api} from "../api/api";
import {Product} from "../product";
import {ACTIVE_BTN_CLASS} from "./consts";

/**
 * Функционал отвечающий за изменение размера на странице товара
 *
 * @class ChangeProductSize
 */
class ChangeProductSize {
  #btnElements;
  #currentActiveBtnElement;

  #api = new Api();
  #product = new Product({});

  constructor() {
    this.#btnElements = Array.from(document.querySelectorAll(`.js-change-product-size`));

    if (!this.#btnElements.length) return;

    this.#init();
  }

  #init() {
    this.#currentActiveBtnElement = this.#btnElements.find((btn) => btn.classList.contains(ACTIVE_BTN_CLASS));

    this.onBtnClick = this.onBtnClick.bind(this);

    this.#btnElements.forEach((btn) => btn.addEventListener(`click`, this.onBtnClick));
  }

  /**
   * Обновление активного состояния кнопки с размером
   *
   * @param {HTMLButtonElement} activeBtnElement
   * @memberof ChangeProductSize
   */
  #updateActiveBtnElement(activeBtnElement) {
    if (this.#currentActiveBtnElement && this.#currentActiveBtnElement !== activeBtnElement) {
      this.#currentActiveBtnElement.classList.remove(ACTIVE_BTN_CLASS);
    }

    activeBtnElement.classList.add(ACTIVE_BTN_CLASS);
    this.#currentActiveBtnElement = activeBtnElement;
  }

  /**
   * Отправление/получение данных с сервера
   *
   * @param {HTMLButtonElement} activeBtnElement
   * @memberof ChangeProductSize
   */
  async #fetchProductInfo(activeBtnElement) {
    const {code, answer} = await this.#api.getProductInfo(activeBtnElement.dataset.productId);

    if (code !== 200) return;

    this.#updateActiveBtnElement(activeBtnElement);
    this.#product.updateProductInfo(answer.data);
  }

  onBtnClick(e) {
    const self = e.currentTarget;

    if (!self.dataset.productId) return;

    e.preventDefault();

    if (self !== this.#currentActiveBtnElement) {
      this.#fetchProductInfo(self);
    }
  }
}

export {ChangeProductSize};
